import React, { MouseEvent } from "react";
import "./ResultPopup.css";
import { usePopup } from "src/contexts/PopupContext";

const ResultPopup: React.FC = () => {
  const {
    isResultPopupVisible,
    resultPopupHeader,
    resultPopupText,
    resultPopupImage,
    setIsResultPopupVisible,
  } = usePopup();

  const hideForm = (event: MouseEvent<HTMLDivElement>) => {
    if (event.target !== event.currentTarget) return;
    setIsResultPopupVisible(false);
  };

  const handleCloseButton = () => {
    setIsResultPopupVisible(false);
  };

  return (
    <>
      {isResultPopupVisible && (
        <div className="result-popup" onClick={hideForm}>
          <div className="result-popup-content">
            {resultPopupHeader && <h2>{resultPopupHeader}</h2>}
            {Array.isArray(resultPopupText) ? (
              <div className="result-popup-text">
                {resultPopupText.map((text, index) => (
                  <p key={`${text}-${index}`}>{text}</p>
                ))}
                {resultPopupImage && (
                  <img
                    src={resultPopupImage}
                    alt="Result"
                    className="result-popup-image"
                  />
                )}
              </div>
            ) : (
              resultPopupText && (
                <div className="result-popup-single-text">
                  <p>{resultPopupText}</p>
                  {resultPopupImage && (
                    <img
                      src={resultPopupImage}
                      alt="Result"
                      className="result-popup-image"
                    />
                  )}
                </div>
              )
            )}
            <button onClick={handleCloseButton}>Terug naar de website</button>
          </div>
        </div>
      )}
    </>
  );
};

export default ResultPopup;
